document.addEventListener(
	'DOMContentLoaded',
	function () {
		const progressBar = document.getElementById('progress-bar__bar');
		const footer = document.querySelector('footer');
		const relatedArticles = document.querySelector('.related-articles');

		const updateProgressBar = () => {
			const scrollTop = window.scrollY;
			const docHeight = document.documentElement.scrollHeight;
			const windowHeight = window.innerHeight;
			const footerHeight = footer ? footer.offsetHeight : 0;
			const relatedArticlesHeight = relatedArticles ? relatedArticles.offsetHeight : 0;
			const adjustedHeight = docHeight - windowHeight - footerHeight - relatedArticlesHeight;

			if (adjustedHeight > 0) {
				//If the article is bigger than viewport
				const scrollPercent = (scrollTop / adjustedHeight) * 100;
				progressBar.style.width = scrollPercent + '%';
			} else {
				//If the article fits viewport and doesnt need scrolling
				progressBar.style.width = '100%';
			}
		};

		window.addEventListener('scroll', updateProgressBar);
	},
	false,
);
